import { OneColumn } from 'components/page';
import { PromocaoGrid } from 'pages/revendedor/promocao/components';

export function PromocaoListComp() {
    return (
        <OneColumn title="Promoções">
            <PromocaoGrid />
        </OneColumn>
    );
}
